// src/components/products/ProductForm/TourDetailsSections/MorningEveningTypeSection.jsx

import React from "react";
import { Grid, Typography, Divider } from "@mui/material";
import FormInput from "../../../inputs/FormInput";
import TimeInput from "../../../inputs/TimeInput";

const MorningEveningTypeSection = ({
    formData,
    setFormData,
    errors,
    isArabic,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Morning Section Title */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                    {isArabic ? '🌅 الفترة الصباحية' : '🌅 Morning Session'}
                </Typography>
            </Grid>

            {/* Morning Operating Hours - Start */}
            <Grid item xs={12} md={6}>
                <TimeInput
                    label={isArabic ? 'وقت بداية الفترة الصباحية' : 'Morning Start Time'}
                    value={formData.morning_operating_hours_start_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        morning_operating_hours_start_time: e.target.value
                    })}
                    required
                    error={!!errors.morning_operating_hours_start_time}
                    helperText={errors.morning_operating_hours_start_time}
                />
            </Grid>

            {/* Morning Operating Hours - End */}
            <Grid item xs={12} md={6}>
                <TimeInput
                    label={isArabic ? 'وقت نهاية الفترة الصباحية' : 'Morning End Time'}
                    value={formData.morning_operating_hours_end_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        morning_operating_hours_end_time: e.target.value
                    })}
                    required
                    error={!!errors.morning_operating_hours_end_time}
                    helperText={errors.morning_operating_hours_end_time}
                />
            </Grid>

            {/* Morning Itinerary - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="خط سير الرحلة الصباحية (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="morning_itinerary_ar"
                        value={formData.morning_itinerary?.ar || ''}
                        onChange={(e) => handleMultiLangChange('morning_itinerary', 'ar', e.target.value)}
                        rows={4}
                        error={!!errors.morning_itinerary_ar}
                        helperText={errors.morning_itinerary_ar}
                    />
                </Grid>
            )}

            {/* Morning Itinerary - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Morning Itinerary (English)"
                        type="editor"
                        textareaRows={200}
                        name="morning_itinerary_en"
                        value={formData.morning_itinerary?.en || ''}
                        onChange={(e) => handleMultiLangChange('morning_itinerary', 'en', e.target.value)}
                        rows={4}
                        error={!!errors.morning_itinerary_en}
                        helperText={errors.morning_itinerary_en}
                    />
                </Grid>
            )}

            {/* Divider */}
            <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
            </Grid>

            {/* Evening Section Title */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                    {isArabic ? '🌆 الفترة المسائية' : '🌆 Evening Session'}
                </Typography>
            </Grid>

            {/* Evening Operating Hours - Start */}
            <Grid item xs={12} md={6}>
                <TimeInput
                    label={isArabic ? 'وقت بداية الفترة المسائية' : 'Evening Start Time'}
                    value={formData.evening_operating_hours_start_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        evening_operating_hours_start_time: e.target.value
                    })}
                    required
                    error={!!errors.evening_operating_hours_start_time}
                    helperText={errors.evening_operating_hours_start_time}
                />
            </Grid>

            {/* Evening Operating Hours - End */}
            <Grid item xs={12} md={6}>
                <TimeInput
                    label={isArabic ? 'وقت نهاية الفترة المسائية' : 'Evening End Time'}
                    value={formData.evening_operating_hours_end_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        evening_operating_hours_end_time: e.target.value
                    })}
                    required
                    error={!!errors.evening_operating_hours_end_time}
                    helperText={errors.evening_operating_hours_end_time}
                />
            </Grid>

            {/* Evening Itinerary - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="خط سير الرحلة المسائية (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="evening_itinerary_ar"
                        value={formData.evening_itinerary?.ar || ''}
                        onChange={(e) => handleMultiLangChange('evening_itinerary', 'ar', e.target.value)}
                        rows={4}
                        error={!!errors.evening_itinerary_ar}
                        helperText={errors.evening_itinerary_ar}
                    />
                </Grid>
            )}

            {/* Evening Itinerary - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Evening Itinerary (English)"
                        type="editor"
                        textareaRows={200}
                        name="evening_itinerary_en"
                        value={formData.evening_itinerary?.en || ''}
                        onChange={(e) => handleMultiLangChange('evening_itinerary', 'en', e.target.value)}
                        rows={4}
                        error={!!errors.evening_itinerary_en}
                        helperText={errors.evening_itinerary_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default MorningEveningTypeSection;
